// extracted by mini-css-extract-plugin
export default {"cp":"cp","cp_buttons":"cp_buttons","button":"button","cp_editor":"cp_editor","modal_mobile":"modal_mobile"};